import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import {
  CLIENT_DASHBOARD_ROUTE,
  MACHADALO_DASHBOARD_ROUTE,
} from '../../constants/routes.constants';
import MachadaloRoutes from '../MachadaloDashboard/routes';
import ClientRoutes from '../ClientDashboard/routes';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { globalpermissions } from '../../Services/Permission.js';
import ProtectedRoute from '../../components/Routes/ProtectedRoute.jsx';

export default function DashboardRoutes(props) {
  const actions = ConstantActions();

  return (
    <Routes>
      {/* <Route path={`machadalo`} element={<MachadaloRoutes />} /> */}
      <Route
        exact
        path={`machadalo`}
        element={
          <ProtectedRoute
            element={<MachadaloRoutes />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.pagePermissions?.businessDashboard,
              globalpermissions?.navBar?.menuOpsDashBoard,
            ])}
          />
        }
      />
      {/* <Route path={`client`} element={<ClientRoutes />} /> */}
      <Route
        exact
        path={`client`}
        element={
          <ProtectedRoute
            element={<ClientRoutes />}
            permissionGranted={actions.userHasPermission([
              globalpermissions?.pagePermissions?.businessDashboard,
              globalpermissions?.navBar?.menuOpsDashBoard,
            ])}
          />
        }
      />
    </Routes>
  );
}
